import { Serializable } from "../utilities/Serializable";

export class CardTransactionProduct extends Serializable {
    product : {};
    quantity : number;
    unitTransactionPrice : Number;
    
    constructor() {
        super();
        this.quantity=1;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/CardTransactionProduct.ts